module.exports = __webpack_public_path__ + "img/phone.f534819a.png";